import CryptoJS from "crypto-js";

export const encryptPassword = async (data: string, salt: string) => {
  const key = CryptoJS.PBKDF2(data, salt, {
    keySize: 32 / 4, // because CryptoJS uses words (32 bits = 4 words)
    iterations: 700,
    hasher: CryptoJS.algo.SHA512,
  });

  return key.toString(CryptoJS.enc.Hex);
};
